import { type MapState } from 'src/types'

const defaultMapState: MapState = {
  switches: {
    day_time: false,
    api_data_loaded: false,
    map_loaded: false,
    game_started: false,
    movement_blocked: false
  },
  counters: {
    player_y: 2,
    player_x: 2,
    tile_size: 24
  },
  variables: {
    location_id: 'walter_home'
  },
  // UI
  contentGrid: [],
  dayLightGrid: [],
  nightLightGrid: [],
  lightGrid: []
}

export {
  defaultMapState
}
